import type { CatalogItem } from '../types';
import { normalizeTurkishText } from './xmlParser';

const isColorCategory = (category: string) => category === 'Renk' || category === 'Kapak Rengi';

/**
 * Matris sekmesindeki bir renk adına karşılık gelen katalog "Renk" öğesini bulur.
 * `findCatalogColorItem`'in aksine kısmi eşleşme yapmaz: görsel yanlış renge
 * bağlanmasın diye yalnızca kod/isim tam eşleşmesi (Türkçe duyarlı) kabul edilir.
 */
export function findExactColorItem(colorName: string, catalog: CatalogItem[]): CatalogItem | null {
  const norm = normalizeTurkishText(colorName);
  if (!norm || !Array.isArray(catalog)) return null;
  return catalog.find(c =>
    c && isColorCategory(c.category) &&
    (normalizeTurkishText(c.code) === norm || normalizeTurkishText(c.name) === norm)
  ) || null;
}

/**
 * Matris rengi için görsel yüklenirken yazılacak katalog öğesini üretir.
 * Mevcut `Renk` öğesi varsa yalnızca görseli güncellenir (kod/isim korunur);
 * yoksa renk adıyla yeni bir `Renk` öğesi oluşturulur. Renk adı başka kategorideki
 * bir ürün koduyla çakışıyorsa o öğenin üzerine yazmamak için kod "RENK " ile öne ekli olur.
 */
export function buildColorCatalogItem(colorName: string, image: string, catalog: CatalogItem[]): CatalogItem {
  const existing = findExactColorItem(colorName, catalog);
  if (existing) return { ...existing, image };

  const name = colorName.trim();
  const clash = catalog.some(c => c && c.code.trim().toUpperCase() === name.toUpperCase());
  return { category: 'Renk', code: clash ? `RENK ${name}` : name, name, image };
}
